module.exports = "/work-site/img/ledimg.37e999a2.png";